import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { mergeQueryString } from 'bernie-core';

import { UitkSelect } from 'uitk-react-input';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';

import { useStores } from '../../../utils/hooks';

export interface DropdownProps {
  field: ActivityDestinationViewSearch.ShoppingDropdownFieldInlineFragment;
  inDialog?: boolean;
  title?: string | null;
}

export const Dropdown: React.FC<DropdownProps> = observer(({ field, inDialog, title }) => {
  const { analytics, activitySearchStore } = useStores();
  const history = useHistory();
  const location = useLocation();
  const selectedSortValue = field.options.find((option) => option.selected)?.value;

  const changeHandler = (event: any): void => {
    const { selectedIndex } = event.target;
    const { selectAnalytics } = field.options[selectedIndex];

    field.options.forEach((option) => {
      option.selected = false;
    });

    field.options[selectedIndex].selected = true;

    activitySearchStore.sortAndFilterObject.initialSelectedSort = field.options[selectedIndex].value;
    analytics.trackEvent(selectAnalytics.referrerId, selectAnalytics.linkName, analytics.omnitureData);
    if (!inDialog) {
      const newQueryString = mergeQueryString(location.search, {
        sort: field.options[selectedIndex].value,
      });
      history.push({
        pathname: location.pathname,
        search: newQueryString,
        state: {},
      });
    }
  };

  return (
    <UitkSelect
      id="sort-select"
      data-testid="sort-dropdown"
      label={title || ''}
      value={selectedSortValue}
      onChange={changeHandler}
    >
      {field?.options.map((option: ActivityDestinationViewSearch.Options, optionIndex: number) => {
        const { value, primary, selected, disabled } = option;

        return (
          <option
            data-testid={`sort-${value}`}
            key={optionIndex}
            value={value}
            aria-selected={selected}
            disabled={disabled}
          >
            {primary}
          </option>
        );
      })}
    </UitkSelect>
  );
});
